import React from 'react';
import { withTheme } from '../ThemeProvider/withTheme';
import { StyledSteps } from './styles';
import type { IStepsProps } from './types';

const StepsComponent: React.FC<IStepsProps> = ({
    current = 0,
    steps,
    hasHover = true,
    variant = 'default',
    ...props
}) => {
    return (
        <StyledSteps
            current={current}
            {...props}
            variant={variant}
            hasHover={hasHover}
        >
            {steps.map((step, index) => (
                <StyledSteps.Step
                    key={index}
                    title={step.title}
                    description={step.description}
                    className="[&_.ant-steps-item-content]:!min-h-0"
                />
            ))}
        </StyledSteps>
    );
};

export const Steps = withTheme(StepsComponent);
